var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.505 4.643h4.99c.45 0 .673.52.357.824L3.356 7.858a.517.517 0 01-.71 0L.148 5.467c-.316-.303-.092-.824.357-.824zm5.347-2.11L3.356.142a.517.517 0 00-.71 0L.148 2.533c-.316.303-.092.824.357.824h4.99c.45 0 .673-.52.357-.824z"
  })));
}
export default SvgDoubleArrow;